import { Controller } from "@hotwired/stimulus"

// 候補者一覧から編集フォームをモーダルで開き、fetch で更新する。
// 成功: モーダルを閉じて一覧を再読み込み / 失敗: エラー付きフォームを再表示
export default class extends Controller {
  static targets = ["dialog", "content"]

  connect() {
    // 画面外クリックで閉じる
    this.dialogTarget.addEventListener("click", (e) => {
      if (e.target === this.dialogTarget) this.close()
    })
    if (this.dialogTarget.open) this.dialogTarget.close()
  }

  async open(event) {
    event.preventDefault()
    const url = event.currentTarget.dataset.candidateEditModalUrl
    if (!url) return
    this.contentTarget.innerHTML = this.loadingHtml()
    this.dialogTarget.showModal()
    const response = await fetch(url, { headers: { "Accept": "text/html" } })
    this.contentTarget.innerHTML = await response.text()
    this.bindForm()
  }

  bindForm() {
    const form = this.contentTarget.querySelector("form")
    if (form) form.addEventListener("submit", this.submit)
  }

  submit = async (event) => {
    event.preventDefault()
    const form = event.currentTarget
    const response = await fetch(form.action, {
      method: form.method,
      body: new FormData(form),
      headers: { "Accept": "text/html", "X-Requested-With": "XMLHttpRequest" }
    })

    if (response.ok) {
      // 更新成功（リダイレクトを追従して 200）→ 閉じて一覧を最新化
      this.dialogTarget.close()
      window.location.reload()
    } else if (response.status === 422) {
      // バリデーションエラー → エラー付きフォームを再表示
      this.contentTarget.innerHTML = await response.text()
      this.bindForm()
    }
  }

  close() {
    this.dialogTarget.close()
  }

  loadingHtml() {
    return '<div class="flex justify-center py-12"><div class="bounce-loader"><div class="dot"></div><div class="dot"></div><div class="dot"></div><div class="dot"></div><div class="dot"></div></div></div>'
  }
}
